import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CreateIcon from '@material-ui/icons/Create';
import './pencil-button.scss';

const PencilButton = (props) => {
  const { onClick } = props;

  return (
    <IconButton
      size="small"
      color="secondary"
      onClick={onClick}
      className="pencil-icon"
    >
      <CreateIcon color="primary" fontSize="small" />
    </IconButton>
  );
};

export default PencilButton;
